import StaticCrumb from '../components/StaticCrumb';
import PromptCrumb from '../components/PromptCrumb';
import FileCrumb from '../components/FileCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const promptsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/prompts',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Prompts',
                href: '/agents/:agentId/prompts',
            },
        },
    ],
    children: [
        {
            path: ':promptId',
            breadcrumbs: [
                {
                    component: PromptCrumb,
                    props: { param: 'promptId' },
                },
            ],
            children: [
                {
                    path: 'file/:fileId',
                    breadcrumbs: [
                        {
                            component: FileCrumb,
                            props: {
                                promptParam: 'promptId',
                                fileParam: 'fileId',
                                isCurrentPage: true,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
